import request from './request'

export interface CareTemplateItem {
  id: number
  item_id: string
  item_name: string
  item_name_zh: string
  type: string
  type_text: string
  section: string
  duration_minutes: number
  duration_text: string
  status: number
}

export interface CareTemplate {
  id: number
  plan_key: string
  plan_text: string
  template_key: string
  template_name: string
  period_type: string
  month: number
  start_month: number | null
  end_month: number | null
  estimated_minutes: number
  estimated_hours: number
  items: CareTemplateItem[]
  baseline_items: CareTemplateItem[]
  routine_items: CareTemplateItem[]
  item_count: number
  status: number
  status_text: string
  sort: number
  create_time: string
  update_time: string
}

export interface CareTemplateListResponseData {
  plan_key: string
  plan_text: string
  list: CareTemplate[]
}

export interface CareTemplateListParams {
  plan_key: string
}

export interface CareTemplateListResponse {
  code: number
  msg: string
  data: CareTemplateListResponseData
}

export interface UpdateTemplateItemsParams {
  template_id: number
  baseline_checklist_ids: number[]
  routine_checklist_ids: number[]
}

export interface UpdateTemplateItemsResponse {
  code: number
  msg: string
  data?: unknown
}

export interface ApplyTemplateParams {
  source_template_id: number
  target_template_id: number
  confirm_replace: number
}

export interface ApplyTemplateResponseData {
  need_confirm_replace: number
  target_template_id: number
  target_item_count: number
}

export interface ApplyTemplateResponse {
  code: number
  msg: string
  data?: ApplyTemplateResponseData
}

export function getCareTemplateList(
  params: CareTemplateListParams,
): Promise<CareTemplateListResponse> {
  return request.post('/api/admin/care-template/list', params)
}

export function updateTemplateItems(
  params: UpdateTemplateItemsParams,
): Promise<UpdateTemplateItemsResponse> {
  return request.post('/api/admin/care-template/update-items', params)
}

export function applyTemplate(params: ApplyTemplateParams): Promise<ApplyTemplateResponse> {
  return request.post('/api/admin/care-template/apply', params)
}

// 获取模板元数据（计划选项和模板信息）
export interface CareTemplateMetaPlan {
  plan_key?: string
  plan_text?: string
  value?: string
  label?: string
}

export function normalizeCareTemplateMetaPlan(plan: CareTemplateMetaPlan): {
  label: string
  value: string
} {
  const value = (plan.plan_key ?? plan.value ?? '').trim()
  const label = (plan.plan_text ?? plan.label ?? value).trim()
  return { label, value }
}

export interface CareTemplateMetaTemplate {
  id: number
  template_key: string
  template_name: string
  plan_key: string
  month: number
  start_month: number | null
  end_month: number | null
}

export interface CareTemplateMetaResponseData {
  plans: CareTemplateMetaPlan[]
  templates: CareTemplateMetaTemplate[]
}

export interface CareTemplateMetaResponse {
  code: number
  msg: string
  data?: CareTemplateMetaResponseData
}

export function getCareTemplateMeta(): Promise<CareTemplateMetaResponse> {
  return request.post('/api/admin/care-template/meta')
}
